import {
    IntroductionParagraph,
    PageTitleSection, SectionDescription,
    TableOfContentItemData,
    TableOfContents
} from "./InfoPageBase";


const TABLE_OF_CONTENT_DATA: TableOfContentItemData[] = [
    {
        title: "INTRO",
        link: "#section-introduction",
    },
    {
        title: "WE DID NOT STEAL",
        link: "#section-collect",
    },
    {
        title: "YOU DID",
        link: "#section-use",
    },
    {
        title: "YOU STEAL",
        link: "#section-cookies",
    },
    {
        title: "GO FUCK YOUR MOM",
        link: "#section-contact",
    },
]

export const TermsOfService = (any) => {
    return (
        <main>
            <PageTitleSection title={"Terms of Service"} dateString={"Last Updated: October 26, 2025"}/>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
                <div className="flex flex-col md:flex-row md:gap-16 lg:gap-24">

                    <TableOfContents tableItems={TABLE_OF_CONTENT_DATA}/>
                    <TermsOfServiceContent />
                    
                </div>
            </div>
        </main>
    );
}

export const TermsOfServiceContent = (any) => {
    const cookiesDescription = 'We use cookies to track the activity on our Service and hold certain information.';

    return (
        <div className="flex-grow min-w-0 prose-invert">
            <section id="section-intro" className="scroll-mt-24">

                <IntroductionParagraph description={"Welcome to Icon Shop. We are committed to protecting your " +
                    "privacy and handling your data in an open and transparent manner. This Privacy Policy details " +
                    "how we collect, use, and share your personal information when you visit our website or use our services."}/>

                <div className="flex-grow min-w-0 prose-invert">

                    <SectionDescription sectionId={"section-cookies"}
                                        subject={"1. Information We Collect"}
                                        description={cookiesDescription}/>

                </div>

            </section>
        </div>
    );
}